import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const VenueSettingsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
}));
